import FormBlock from 'components/formComponents/Layout/FormBlock';
import React, { useMemo } from 'react';
import UnionOrganizationSelect from './UnionOrganizationSelect';
import UnionContactDetails from './UnionContactDetails';
import { useAppSelector } from '../../../../../hooks';

const UnionSection = () => {
  const { pageTexts } = useAppSelector((state) => state.partyApplication);
  const texts = useMemo(() => {
    return pageTexts?.unionSection;
  }, [pageTexts]);

  return (
    <FormBlock title="Fackförbund och kontaktuppgifter">
      <UnionOrganizationSelect texts={texts} />
      <UnionContactDetails texts={texts} />
    </FormBlock>
  );
};

export default UnionSection;
